import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgAnchorIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M32 9.6a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4m-6.4 3.2a6.4 6.4 0 1 1 8 6.198V24h8v3.2h-8V48h4.411a3.2 3.2 0 0 0 2.263-.937l7.863-7.863-.8-.8H41.6v-3.2h5.737a3.2 3.2 0 0 1 2.263.937L53.462 40c.6.6.938 1.414.938 2.263V48h-3.2v-5.737l-.8-.8-7.863 7.862A6.4 6.4 0 0 1 38.01 51.2H25.989a6.4 6.4 0 0 1-4.526-1.875L13.6 41.463l-.8.8V48H9.6v-5.737A3.2 3.2 0 0 1 10.537 40l3.863-3.863a3.2 3.2 0 0 1 2.262-.937H22.4v3.2h-5.738l-.8.8 7.863 7.863a3.2 3.2 0 0 0 2.263.937H30.4V27.2h-8V24h8v-5.002a6.4 6.4 0 0 1-4.8-6.198"
    />
  </svg>
)
export default SvgAnchorIcon
